import type { ReactElement } from 'react'
import { microMoney, procedureGroups } from 'app/components/action-center/treatmentDisplay'
import { useCdtCodeMappings } from 'app/hooks/useCdtCodeMappings'
import { cn } from 'app/lib/utils'
import type { TreatmentCard } from 'app/types/treatment'

export function ProcedureGroupsSection({ card }: { card: TreatmentCard }): ReactElement {
  const { categoryOf } = useCdtCodeMappings()
  return (
    <div className="mt-2.5 space-y-0.5">
      {procedureGroups(card, categoryOf).map((group) => (
        <div key={group.label} className="flex items-baseline justify-between gap-2 text-body-xs">
          <span className={cn(`min-w-0 truncate`, group.rest ? `text-minimal` : `text-subtle`)}>
            {group.rest ? `+${group.count} more` : group.label}
          </span>
          <span className={cn(`shrink-0 tabular-nums`, group.rest ? `text-minimal` : `text-subtle`)}>
            {microMoney(group.fee)}
          </span>
        </div>
      ))}
    </div>
  )
}
